import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { phoenixAuthTypes, PhoenixLinkedService } from 'app/model/linkedservice/phoenix.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { PhoenixCopySource } from 'app/model/pipeline/copysource/phoenix.copysource';
import { enableSslWithTUAARadioSwitch } from './linked-service-shared-fields';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const phoenixMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(PhoenixLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Phoenix_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-phoenix'
    },
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    isFirstClass: true,
    category: ['Database'],
    supportDatasetV2: true,
    notShowInTypeSelection: true,
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(PhoenixCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'host',
            label: stringResources.ModelName_Host,
            required: true,
            placeholder: stringResources.Host_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            warningMessageCalculator: (value: string) =>
                stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning,
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'port',
            label: stringResources.ModelName_Port,
            isLabelVertical: true,
            inputType: 'number',
            defaultValue: 443,
            min: 0
        },
        {
            type: 'textbox',
            bind: 'httpPath',
            label: stringResources.ModelName_HttpPath,
            placeholder: stringResources.Phoenix_LinkedService_HttpPath_Placeholder,
            isLabelVertical: true
        },
        {
            type: 'select-switch',
            bind: 'authenticationType',
            label: stringResources.ModelName_AuthenticationType,
            options: [
                {
                    label: stringResources.Anonymous_DisplayText,
                    value: phoenixAuthTypes.Anonymous
                },
                {
                    label: stringResources.AuthenticationType_UsernameAndPassword,
                    value: phoenixAuthTypes.UsernameAndPassword
                },
                {
                    label: stringResources.AuthenticationType_WindowsAzureHDInsightService,
                    value: phoenixAuthTypes.WindowsAzureHDInsightService
                }
            ],
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true,
            defaultValue: phoenixAuthTypes.Anonymous,
            cases: [
                {
                    caseValue: phoenixAuthTypes.UsernameAndPassword,
                    children: [
                        {
                            type: 'textbox',
                            bind: 'username',
                            label: stringResources.ModelName_UserName,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {
                            type: 'dynamic-akv-switcher',
                            bind: 'password',
                            label: stringResources.ModelName_Password,
                            child: {
                                type: 'password',
                                label: stringResources.ModelName_Password,
                                required: true,
                                isLabelVertical: true
                            },
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Phoenix_DisplayText),
                                stringResources.ModelName_Password)
                        }
                    ]
                },
                {
                    caseValue: phoenixAuthTypes.WindowsAzureHDInsightService,
                    children: [
                        {
                            type: 'textbox',
                            bind: 'username',
                            label: stringResources.ModelName_UserName,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            isLabelVertical: true
                        },
                        {
                            type: 'dynamic-akv-switcher',
                            bind: 'password',
                            label: stringResources.ModelName_Password,
                            child: {
                                type: 'password',
                                label: stringResources.ModelName_Password,
                                required: true,
                                isLabelVertical: true
                            },
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ],
                            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Phoenix_DisplayText),
                                stringResources.ModelName_Password)
                        }
                    ]
                }
            ]
        },
        enableSslWithTUAARadioSwitch
    ]
};
